import { render, staticRenderFns } from "./SetUserinfo.vue?vue&type=template&id=711d6580&scoped=true"
import script from "./SetUserinfo.vue?vue&type=script&lang=js"
export * from "./SetUserinfo.vue?vue&type=script&lang=js"
import style0 from "./SetUserinfo.vue?vue&type=style&index=0&id=711d6580&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "711d6580",
  null
  
)

export default component.exports